import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip"

interface BillableActionInfoProps {
  align?: "left" | "right"
}

export function BillableActionInfo({ align = "right" }: BillableActionInfoProps) {
  return (
    <div className={`${align === "left" ? "text-left" : "text-right"} text-xs text-gray-600 mt-1`}>
      Our AI generates ideas to inspire you. Results may vary.{" "}
      <TooltipProvider delayDuration={500}>
        <Tooltip>
          <TooltipTrigger asChild>
            <button className="text-teal-600 hover:text-teal-700 focus:outline-none">Why?</button>
          </TooltipTrigger>
          <TooltipContent className="max-w-md text-center">
            <p>
              Our AI is trained on thousands of professional interior designs and takes into account factors like room
              dimensions, style preferences, and color schemes. That said, AI isn&apos;t perfect and will sometimes make
              mistakes. The goal of the app is to inspire design thinking and make interior design more accessible, not
              to produce a completely accurate rendering of your room. Results may vary based on your room&apos;s layout
              and original photo quality.
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  )
}
